import { type ReactElement, useEffect, useRef } from "react"

import { ErrorPage } from "@/components/global/Errors/ErrorPage"
import { logEvent } from "@/util/telemetry"
import { viewManager } from "@/util/viewManager"

function useMaintenancePageTelemetry(): void {
  const hasLogged = useRef(false)

  useEffect(() => {
    if (hasLogged.current) {
      return
    }
    hasLogged.current = true

    logEvent("warning", "Maintenance page rendered", {
      context: {
        org: viewManager.get("org"),
        user: viewManager.get("user"),
        transactionId: viewManager.get("transactionId"),
      },
      fingerprint: ["maintenance-page-rendered"],
      sentryContext: "MaintenancePage",
    })
  }, [])
}

export function UnavailablePage(): ReactElement {
  useMaintenancePageTelemetry()

  return (
    <ErrorPage
      title="OneSchema is under maintenance"
      subtitle="We're performing scheduled maintenance and will be back shortly. Please try again in a few minutes."
      returnUrl=""
      returnText=""
    />
  )
}
